<template>
	<div class="value-row">
		<label :for="forId">
			{{ label }}
		</label>
		<hr />
		<slot />
	</div>
</template>

<script lang="ts" setup>
defineProps<{
	forId: string;
	label: string;
}>();
</script>
